import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ 
  children, 
  variant = "primary", 
  size = "md", 
  href, 
  onClick, 
  className = "",
  disabled = false,
  type = "button"
}) => {
  const baseClass = `btn btn-${variant} btn-${size}`;
  const buttonClass = `${baseClass} ${className}`;

  if (href) {
    return (
      <Link to={href} className={buttonClass} onClick={onClick}>
        {children}
      </Link>
    );
  }

  return (
    <button 
      type={type}
      className={buttonClass} 
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
